import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Button, message } from 'antd';
import { AppDispatch, RootState } from '../../../redux/store/store';
import { updateEmpresa } from '../../../redux/actions/empresas/Empresas';

interface EditarEmpresaModalProps {
  visible: boolean;
  empresaId: number | null;
  onClose: (refresh?: boolean) => void;
}

const EditarEmpresaModal: React.FC<EditarEmpresaModalProps> = ({
  visible,
  empresaId,
  onClose
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const { empresas } = useSelector((state: RootState) => state.empresas);
  const currentEmpresa = empresas.find(e => e.id === empresaId);

  useEffect(() => {
    if (currentEmpresa) {
      form.setFieldsValue({
        nombre: currentEmpresa.nombre
      });
    }
  }, [currentEmpresa, form]);

  const handleSubmit = async () => {
    if (!empresaId) return;

    try {
      const values = await form.validateFields();
      setLoading(true);
      await dispatch(updateEmpresa(empresaId.toString(), values));
      message.success('Empresa actualizada exitosamente');
      onClose(true);
    } catch (error) {
      console.error('Error al actualizar la empresa:', error);
      message.error('Error al actualizar la empresa');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };
  
  if (!currentEmpresa && empresaId !== null) {
    return null;
  }

  return (
    <Modal
      title="Editar Empresa"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Guardar Cambios
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_editar_empresa"
      >
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[
            {
              required: true,
              message: 'Por favor ingrese el nombre de la empresa',
            },
          ]}
        >
          <Input placeholder="Ej. Empresa Principal" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditarEmpresaModal;